function openCustomTab(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("custom-tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("custom-tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active-tab", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active-tab";
}

// Get the element with id="defaultCustomOpen" and click on it
document.getElementById("defaultCustomOpen").click();

var swiper = new Swiper(".celediTabs", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  mousewheel: {
    forceToAxis: true,
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 4,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 4,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 4,
    },
  },
});
